import React from 'react';
import PropTypes from 'prop-types';
import { formatCurrency } from '../../utils/stringUtils';

const CurrencyFormat = ({ value, className, prefix }) => {
  const formattedValue =
    typeof value === 'number' ? formatCurrency(value) : formatCurrency(0);

  return (
    <span className={className}>
      {prefix}
      {formattedValue}
    </span>
  );
};

CurrencyFormat.propTypes = {
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  className: PropTypes.string,
  prefix: PropTypes.string,
};

CurrencyFormat.defaultProps = {
  value: 0,
  className: '',
  prefix: '',
};

export default CurrencyFormat;
